import { normalize_text, object_field } from './view_case_details_core_helpers';

const CHOICE_LABEL_FIELDS = ['option', 'choice', 'label', 'value', 'text'];
const CHOICE_WEIGHT_FIELDS = ['weight', 'score', 'risk_weight'];

export function first_present(values = []) {
  return values.find((value) => value !== undefined && value !== null && value !== '');
}

export function normalize_label(value = '') {
  return normalize_text(value).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
}

export function field_value(record = {}, field = '') {
  return object_field(record, field);
}

export function first_field_value(record = {}, fields = []) {
  return first_present(fields.map((field) => field_value(record, field)));
}

function is_scalar_choice(choice) {
  return ['string', 'number'].includes(typeof choice);
}

export function risk_choice_label(choice = {}) {
  return normalize_text(is_scalar_choice(choice) ? choice : first_field_value(choice, CHOICE_LABEL_FIELDS));
}

export function risk_choice_weight(choice = {}) {
  const weight = Number(first_field_value(choice, CHOICE_WEIGHT_FIELDS) ?? 0);
  return Number.isFinite(weight) ? weight : 0;
}
